import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { useModule } from '../../contexts/ModuleContext';
import { LogOut, User, Menu } from 'lucide-react';
import NotificationsDropdown from '../notifications/NotificationsDropdown';
import ThemeSwitcher from '../ThemeSwitcher';
import ModuleSwitcher from './ModuleSwitcher';

const Navbar = ({ onMenuClick }) => {
  const { user, logout } = useAuth();
  const { activeModule } = useModule();

  const handleLogout = () => {
    if (window.confirm('Are you sure you want to logout?')) {
      logout();
    }
  };

  return (
    <>
      <nav className="bg-theme-secondary border-b border-theme px-4 md:px-6 py-4 transition-colors">
        <div className="flex items-center justify-between">
          {/* Left side - Menu button (mobile) + Greeting */}
          <div className="flex items-center gap-4">
            {/* Hamburger Menu - Mobile Only */}
            <button
              onClick={onMenuClick}
              className="lg:hidden p-2 hover:bg-theme-tertiary rounded-lg transition-colors"
            >
              <Menu className="w-6 h-6 text-theme-secondary" />
            </button>

            {/* Greeting */}
            <div>
              <h2 className="text-xs md:text-xl font-semibold text-theme-primary">
                Welcome back, {user?.full_name || 'User'}!
              </h2>
              <p className="text-xs md:text-sm text-theme-secondary capitalize">
                Role: <span className="font-medium">{user?.role?.replace('_', ' ')}</span>
              </p>
            </div>
          </div>

          {/* Right side - Actions */}
          <div className="flex items-center gap-2 md:gap-4">
            {/* Module Switcher - Only for multi-module roles */}
            <ModuleSwitcher />

            {/* Theme Switcher */}
            <ThemeSwitcher variant="navbar" />

            {/* Notifications - Only show in Retail module */}
            {activeModule === 'retail' && <NotificationsDropdown />}

            {/* Profile - Hidden on small screens */}
            <div className="hidden md:flex items-center gap-3 px-3 py-2 hover:bg-theme-tertiary rounded-lg transition-colors cursor-pointer">
              <div className="w-8 h-8 bg-accent-gold rounded-full flex items-center justify-center">
                <User className="w-5 h-5 text-primary-black" />
              </div>
              <span className="text-sm font-medium text-theme-primary">{user?.full_name}</span>
            </div>

            {/* Logout */}
            <button
              onClick={handleLogout}
              className="flex items-center gap-2 px-3 md:px-4 py-2 text-red-600 hover:bg-red-50 rounded-lg transition-colors"
            >
              <LogOut className="w-5 h-5" />
              <span className="hidden sm:inline text-sm font-medium">Logout</span>
            </button>
          </div>
        </div>
      </nav>
    </>
  );
};

export default Navbar;
